import { render } from "./TransactionHistoryAdditionalInformation.vue?vue&type=template&id=fd78523e&scoped=true"
import script from "./TransactionHistoryAdditionalInformation.vue?vue&type=script&lang=js"
export * from "./TransactionHistoryAdditionalInformation.vue?vue&type=script&lang=js"

import "./TransactionHistoryAdditionalInformation.vue?vue&type=style&index=0&id=fd78523e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd78523e"]])

export default __exports__